import "@skjnldsv/vue-plyr/dist/vue-plyr.css";
const vuePlyr = {
  install: async (app) => {
    if (typeof process === "undefined" || process.client) {
      const VuePlyr = await import("@skjnldsv/vue-plyr");
      app.use(VuePlyr.default);
    }
  }
};
export {
  vuePlyr as default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidnVlLXBseXIuanMiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9wbHVnaW5zL2JhbnphL3Z1ZS1wbHlyLmpzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBcIkBza2pubGRzdi92dWUtcGx5ci9kaXN0L3Z1ZS1wbHlyLmNzc1wiO1xuXG5leHBvcnQgZGVmYXVsdCB7XG4gIGluc3RhbGw6IGFzeW5jIChhcHApID0+IHtcbiAgICBpZiAodHlwZW9mIHByb2Nlc3MgPT09IFwidW5kZWZpbmVkXCIgfHwgcHJvY2Vzcy5jbGllbnQpIHtcbiAgICAgIGNvbnN0IFZ1ZVBseXIgPSBhd2FpdCBpbXBvcnQoXCJAc2tqbmxkc3YvdnVlLXBseXJcIik7XG4gICAgICBhcHAudXNlKFZ1ZVBseXIuZGVmYXVsdCk7XG4gICAgfVxuICB9LFxufTtcbiJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBRUEsTUFBZSxVQUFBO0FBQUEsRUFDYixTQUFTLE9BQU8sUUFBUTtBQUN0QixRQUFJLE9BQU8sWUFBWSxlQUFlLFFBQVEsUUFBUTtBQUNwRCxZQUFNLFVBQVUsTUFBTSxPQUFPLG9CQUFvQjtBQUNqRCxVQUFJLElBQUksUUFBUSxPQUFPO0FBQUEsSUFDN0I7QUFBQSxFQUNHO0FBQ0g7In0=
